// Lista de países con sus códigos ISO
export const countries = [
  { code: 'AD', name: 'Andorra' },
  { code: 'AE', name: 'Emiratos Árabes Unidos' },
  { code: 'AF', name: 'Afganistán' },
  { code: 'AG', name: 'Antigua y Barbuda' },
  { code: 'AI', name: 'Anguilla' },
  { code: 'AL', name: 'Albania' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AO', name: 'Angola' },
  { code: 'AQ', name: 'Antártida' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AS', name: 'Samoa Americana' },
  { code: 'AT', name: 'Austria' },
  { code: 'AU', name: 'Australia' },
  { code: 'AW', name: 'Aruba' },
  { code: 'AX', name: 'Islas Åland' },
  { code: 'AZ', name: 'Azerbaiyán' },
  { code: 'BA', name: 'Bosnia y Herzegovina' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BE', name: 'Bélgica' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BH', name: 'Bahrein' },
  { code: 'BI', name: 'Burundi' },
  { code: 'BJ', name: 'Benín' },
  { code: 'BL', name: 'San Bartolomé' },
  { code: 'BM', name: 'Bermudas' },
  { code: 'BN', name: 'Brunéi' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BQ', name: 'Bonaire, San Eustaquio y Saba' },
  { code: 'BR', name: 'Brasil' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BT', name: 'Bután' },
  { code: 'BV', name: 'Isla Bouvet' },
  { code: 'BW', name: 'Botsuana' },
  { code: 'BY', name: 'Bielorrusia' },
  { code: 'BZ', name: 'Belice' },
  { code: 'CA', name: 'Canadá' },
  { code: 'CC', name: 'Islas Cocos' },
  { code: 'CD', name: 'República Democrática del Congo' },
  { code: 'CF', name: 'República Centroafricana' },
  { code: 'CG', name: 'Congo' },
  { code: 'CH', name: 'Suiza' },
  { code: 'CI', name: 'Costa de Marfil' },
  { code: 'CK', name: 'Islas Cook' },
  { code: 'CL', name: 'Chile' },
  { code: 'CM', name: 'Camerún' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CV', name: 'Cabo Verde' },
  { code: 'CW', name: 'Curaçao' },
  { code: 'CX', name: 'Isla de Navidad' },
  { code: 'CY', name: 'Chipre' },
  { code: 'CZ', name: 'República Checa' },
  { code: 'DE', name: 'Alemania' },
  { code: 'DJ', name: 'Yibuti' },
  { code: 'DK', name: 'Dinamarca' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'República Dominicana' },
  { code: 'DZ', name: 'Argelia' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EE', name: 'Estonia' },
  { code: 'EG', name: 'Egipto' },
  { code: 'EH', name: 'Sáhara Occidental' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'ES', name: 'España' },
  { code: 'ET', name: 'Etiopía' },
  { code: 'FI', name: 'Finlandia' },
  { code: 'FJ', name: 'Fiyi' },
  { code: 'FK', name: 'Islas Malvinas' },
  { code: 'FM', name: 'Micronesia' },
  { code: 'FO', name: 'Islas Feroe' },
  { code: 'FR', name: 'Francia' },
  { code: 'GA', name: 'Gabón' },
  { code: 'GB', name: 'Reino Unido' },
  { code: 'GD', name: 'Granada' },
  { code: 'GE', name: 'Georgia' },
  { code: 'GF', name: 'Guayana Francesa' },
  { code: 'GG', name: 'Guernsey' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GI', name: 'Gibraltar' },
  { code: 'GL', name: 'Groenlandia' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GP', name: 'Guadalupe' },
  { code: 'GQ', name: 'Guinea Ecuatorial' },
  { code: 'GR', name: 'Grecia' },
  { code: 'GS', name: 'Islas Georgias del Sur y Sandwich del Sur' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GU', name: 'Guam' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'HM', name: 'Islas Heard y McDonald' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HR', name: 'Croacia' },
  { code: 'HT', name: 'Haití' },
  { code: 'HU', name: 'Hungría' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IE', name: 'Irlanda' },
  { code: 'IL', name: 'Israel' },
  { code: 'IM', name: 'Isla de Man' },
  { code: 'IN', name: 'India' },
  { code: 'IO', name: 'Territorio Británico del Océano Índico' },
  { code: 'IQ', name: 'Irak' },
  { code: 'IR', name: 'Irán' },
  { code: 'IS', name: 'Islandia' },
  { code: 'IT', name: 'Italia' },
  { code: 'JE', name: 'Jersey' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JO', name: 'Jordania' },
  { code: 'JP', name: 'Japón' },
  { code: 'KE', name: 'Kenia' },
  { code: 'KG', name: 'Kirguistán' },
  { code: 'KH', name: 'Camboya' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KM', name: 'Comoras' },
  { code: 'KN', name: 'San Cristóbal y Nieves' },
  { code: 'KP', name: 'Corea del Norte' },
  { code: 'KR', name: 'Corea del Sur' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KY', name: 'Islas Caimán' },
  { code: 'KZ', name: 'Kazajstán' },
  { code: 'LA', name: 'Laos' },
  { code: 'LB', name: 'Líbano' },
  { code: 'LC', name: 'Santa Lucía' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LS', name: 'Lesoto' },
  { code: 'LT', name: 'Lituania' },
  { code: 'LU', name: 'Luxemburgo' },
  { code: 'LV', name: 'Letonia' },
  { code: 'LY', name: 'Libia' },
  { code: 'MA', name: 'Marruecos' },
  { code: 'MC', name: 'Mónaco' },
  { code: 'MD', name: 'Moldavia' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MF', name: 'San Martín' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MH', name: 'Islas Marshall' },
  { code: 'MK', name: 'Macedonia del Norte' },
  { code: 'ML', name: 'Mali' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'MO', name: 'Macao' },
  { code: 'MP', name: 'Islas Marianas del Norte' },
  { code: 'MQ', name: 'Martinica' },
  { code: 'MR', name: 'Mauritania' },
  { code: 'MS', name: 'Montserrat' },
  { code: 'MT', name: 'Malta' },
  { code: 'MU', name: 'Mauricio' },
  { code: 'MV', name: 'Maldivas' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MX', name: 'México' },
  { code: 'MY', name: 'Malasia' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NC', name: 'Nueva Caledonia' },
  { code: 'NE', name: 'Níger' },
  { code: 'NF', name: 'Isla Norfolk' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NL', name: 'Países Bajos' },
  { code: 'NO', name: 'Noruega' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NU', name: 'Niue' },
  { code: 'NZ', name: 'Nueva Zelanda' },
  { code: 'OM', name: 'Omán' },
  { code: 'PA', name: 'Panamá' },
  { code: 'PE', name: 'Perú' },
  { code: 'PF', name: 'Polinesia Francesa' },
  { code: 'PG', name: 'Papúa Nueva Guinea' },
  { code: 'PH', name: 'Filipinas' },
  { code: 'PK', name: 'Pakistán' },
  { code: 'PL', name: 'Polonia' },
  { code: 'PM', name: 'San Pedro y Miquelón' },
  { code: 'PN', name: 'Pitcairn' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'PS', name: 'Palestina' },
  { code: 'PT', name: 'Portugal' },
  { code: 'PW', name: 'Palau' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'QA', name: 'Catar' },
  { code: 'RE', name: 'Reunión' },
  { code: 'RO', name: 'Rumania' },
  { code: 'RS', name: 'Serbia' },
  { code: 'RU', name: 'Rusia' },
  { code: 'RW', name: 'Ruanda' },
  { code: 'SA', name: 'Arabia Saudita' },
  { code: 'SB', name: 'Islas Salomón' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SD', name: 'Sudán' },
  { code: 'SE', name: 'Suecia' },
  { code: 'SG', name: 'Singapur' },
  { code: 'SH', name: 'Santa Elena' },
  { code: 'SI', name: 'Eslovenia' },
  { code: 'SJ', name: 'Svalbard y Jan Mayen' },
  { code: 'SK', name: 'Eslovaquia' },
  { code: 'SL', name: 'Sierra Leona' },
  { code: 'SM', name: 'San Marino' },
  { code: 'SN', name: 'Senegal' },
  { code: 'SO', name: 'Somalia' },
  { code: 'SR', name: 'Surinam' },
  { code: 'SS', name: 'Sudán del Sur' },
  { code: 'ST', name: 'Santo Tomé y Príncipe' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'SX', name: 'Sint Maarten' },
  { code: 'SY', name: 'Siria' },
  { code: 'SZ', name: 'Esuatini' },
  { code: 'TC', name: 'Islas Turcas y Caicos' },
  { code: 'TD', name: 'Chad' },
  { code: 'TF', name: 'Tierras Australes Francesas' },
  { code: 'TG', name: 'Togo' },
  { code: 'TH', name: 'Tailandia' },
  { code: 'TJ', name: 'Tayikistán' },
  { code: 'TK', name: 'Tokelau' },
  { code: 'TL', name: 'Timor Oriental' },
  { code: 'TM', name: 'Turkmenistán' },
  { code: 'TN', name: 'Túnez' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TR', name: 'Turquía' },
  { code: 'TT', name: 'Trinidad y Tobago' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'TW', name: 'Taiwán' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'UA', name: 'Ucrania' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UM', name: 'Islas Ultramarinas de Estados Unidos' },
  { code: 'US', name: 'Estados Unidos' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistán' },
  { code: 'VA', name: 'Vaticano' },
  { code: 'VC', name: 'San Vicente y las Granadinas' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VG', name: 'Islas Vírgenes Británicas' },
  { code: 'VI', name: 'Islas Vírgenes de Estados Unidos' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'WF', name: 'Wallis y Futuna' },
  { code: 'WS', name: 'Samoa' },
  { code: 'YE', name: 'Yemen' },
  { code: 'YT', name: 'Mayotte' },
  { code: 'ZA', name: 'Sudáfrica' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabue' }
];

export default countries;
